var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-date"},[_c('img',{staticClass:"current-date__icon",attrs:{"src":require("@/assets/images/RU/calendar-icon.png"),"alt":""}}),_c('span',{staticClass:"current-date__text"},[_vm._v(_vm._s(_vm.currentDate))])])}
var staticRenderFns = []

export { render, staticRenderFns }